import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useState, useMemo, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore"; // ใช้ selector และ dispatch จาก Redux
import { getAllMember } from "../../redux/handlers/logic/getAllMember.handler";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { debounce } from "lodash";
export var useGetAllMember = function() {
    var isBoSale = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).isBoSale;
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var reducers = {
        members: useAppSelector(function(state) {
            return state.getAllMemberReducer;
        })
    };
    // Local state
    var _useState = _sliced_to_array(useState([]), 2), members = _useState[0], setMembers = _useState[1];
    var debouncedSearch = useMemo(function() {
        return debounce(function(searchText) {
            var queryParams = _object_spread({
                searchText: searchText
            }, isBoSale !== undefined && {
                isBoSale: isBoSale
            });
            dispatch(getAllMember({
                queryParams: queryParams,
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }, 300);
    }, [
        members
    ]);
    var isGetAllMemberLoading = useMemo(function() {
        return reducers.members.isFetching;
    }, [
        reducers.members.isFetching
    ]);
    var handleSearchChange = function(value) {
        if (value) {
            debouncedSearch(value);
        }
    };
    // Handle incoming data
    useEffect(function() {
        if (reducers.members.data) {
            setMembers(reducers.members.data.data);
        }
    }, [
        reducers.members.data
    ]);
    return {
        handleSearchChange: handleSearchChange,
        members: members,
        isGetAllMemberLoading: isGetAllMemberLoading
    };
};
